import { RuleProps } from 'types/application';
import { SECT_PUB_DETAILS } from './pubDetails';

const PUBLICATION_TITLE = [
    {
        sectionID: SECT_PUB_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: 'publication-type',
                label: 'Type of Publication',
                type: 'text',
                apiID: 'IMDA-IRIS-Work-Publication-Type',
                rule: { required: true }
            },
            {
                id: 'empty-1',
                label: '',
                type: '',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-item-type`,
                //         ifNotList: ['others'],
                //         hide: true
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: ['Other Types of Publications'],
                //         hide: true,
                //         setValue: () => ''
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-item-type`, `${SECT_PUB_DETAILS}-publication-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_PUB_DETAILS}-pe-type`] !== 'others' ||
                                    baseValues[`${SECT_PUB_DETAILS}-publication-type`] !== 'Other Types of Publications')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'item-type',
                label: 'Item Type',
                type: 'dropdown',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: ['Other Types of Publications'],
                //         required: true
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: ['Other Types of Publications'],
                //         hide: true,
                //         setValue: () => ''
                //     }
                // ],
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`] === 'Other Types of Publications'
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`] !== 'Other Types of Publications'
                        );
                        return result;
                    }
                },
                options: [
                    {
                        optID: 'calendar',
                        optLabel: 'Calendar'
                    },
                    {
                        optID: 'catalogue',
                        optLabel: 'Catalogue'
                    },
                    {
                        optID: 'key-chain',
                        optLabel: 'Key Chain'
                    },
                    {
                        optID: 'post-card',
                        optLabel: 'Post Card'
                    },
                    {
                        optID: 'poster',
                        optLabel: 'Poster'
                    },
                    {
                        optID: 'playing-card',
                        optLabel: 'Playing Card'
                    },
                    {
                        optID: 't-shirt',
                        optLabel: 'T-Shirt'
                    },
                    {
                        optID: 'others',
                        optLabel: 'Others'
                    }
                ]
            },
            {
                id: 'empty-2',
                label: '',
                type: '',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: ['Other Types of Publications'],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`] === 'Other Types of Publications'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'other-item-type',
                label: 'Other Item Type Description',
                type: 'text',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-item-type`,
                //         ifList: ['others'],
                //         required: true,
                //         charLength: 20
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-item-type`,
                //         ifNotList: ['others'],
                //         hide: true
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: [''],
                //         hide: true
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: ['Other Types of Publications'],
                //         hide: true,
                //         setValue: () => ''
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-item-type`, `${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 20,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-item-type`] === 'others');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_PUB_DETAILS}-item-type`] !== 'others' ||
                                    !baseValues[`${SECT_PUB_DETAILS}-publication-type`] ||
                                    baseValues[`${SECT_PUB_DETAILS}-publication-type`] !== 'Other Types of Publications')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'publication-title',
                label: 'Title',
                type: 'text',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: [''],
                //         required: true,
                //         charLength: 200
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: [''],
                //         hide: true,
                //         setValue: () => ''
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 200,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return !result;
                    },
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (currentValue) {
                            const result = /(\b((https?|ftp|file):\/\/|(www\.))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig.test(
                                currentValue as string
                            );
                            if (result) return 'URL Not Allowed in Title.';
                        }

                        return true;
                    }
                }
            },
            {
                id: 'romanized-title',
                label: 'Romanized Title',
                type: 'text',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: [''],
                //         charLength: 200
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: [''],
                //         hide: true
                //     },
                //     {
                //         pattern: /^[a-z0-9_.,'"!?;:&()= ]+$/i
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 200,
                    // pattern: /^[a-z0-9_.,'"!?;:&()= ]+$/i,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return !result;
                    },
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (currentValue) {
                            const result = /^[a-z0-9_.,'"!?;:&()= ]+$/.test(currentValue as string);
                            if (!result) return 'Only English inputs are accepted.';
                        }

                        return true;
                    }
                }
            },
            {
                id: 'isbn-no',
                label: 'ISBN No.',
                type: 'text',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: ['Book'],
                //         charLength: 20
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: ['Book'],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 20,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`] === 'Book');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`] === 'Book');
                        return !result;
                    }
                }
            },
            {
                id: 'issn-no',
                label: 'ISSN No.',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 20,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && ['Comic', 'Magazine'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return !result;
                    }
                }
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: ['Comic', 'Magazine'],
                //         charLength: 20
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: ['Comic', 'Magazine'],
                //         hide: true
                //     }
                // ]
            },
            {
                id: 'language',
                apiID: 'Language',
                label: 'Language',
                type: 'dropdown',
                options: [
                    {
                        optID: 'SG',
                        optLabel: 'Singapore'
                    }
                ],
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: [''],
                //         charLength: 200,
                //         required: true
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: [''],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 200,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return !result;
                    }
                }
            },
            {
                id: 'language-description',
                label: 'Language Description',
                type: 'text',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-language`,
                //         ifList: ['XX'], // others
                //         required: true,
                //         charLength: 50
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-language`,
                //         ifNotList: ['XX'],
                //         hide: true,
                //         setValue: () => ''
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-language`],
                    charLength: 50,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-language`] === 'XX'); // XX = others
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-language`] === 'XX');
                        return !result;
                    }
                }
            },
            {
                id: 'issue-no',
                label: 'Issue No.',
                type: 'text',
                required: true,
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: ['Comic', 'Magazine'],
                //         charLength: 50,
                //         required: true
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: ['Comic', 'Magazine'],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 50,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && ['Comic', 'Magazine'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && ['Comic', 'Magazine'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return !result;
                    }
                }
            },
            {
                id: 'author',
                label: 'Author',
                type: 'text',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: ['Comic', 'Book'],
                //         required: true,
                //         charLength: 100
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: ['Comic', 'Book'],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 100,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && ['Comic', 'Book'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && ['Comic', 'Book'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return !result;
                    }
                }
            },
            {
                id: 'artiste',
                label: 'Artiste',
                type: 'text',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: ['Audio'],
                //         required: true,
                //         charLength: 100
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: ['Audio'],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 100,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && ['Audio'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && ['Audio'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return !result;
                    }
                }
            },
            {
                id: 'publisher',
                label: 'Publisher',
                type: 'text',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: ['Book', 'Comic'],
                //         required: true,
                //         charLength: 100
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: ['Book', 'Comic'],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 100,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                ['Comic', 'Book', 'Newspaper'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                ['Comic', 'Book', 'Newspaper'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return !result;
                    }
                }
            },
            {
                id: 'volume-no',
                label: 'Volume No.',
                type: 'number',
                rule: {
                    charLength: 9,
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && ['Comic'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && ['Comic'].includes(baseValues[`${SECT_PUB_DETAILS}-publication-type`] as string)
                        );
                        return !result;
                    }
                }
            },
            {
                id: 'country-published',
                apiID: 'Country',
                label: 'Country Published In',
                type: 'dropdown',
                required: true,
                options: [
                    {
                        optID: 'SG',
                        optLabel: 'Singapore'
                    }
                ],
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: [''],
                //         required: true
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: [''],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return !result;
                    }
                }
            },
            {
                id: 'other-country',
                label: 'Other Country',
                type: 'text',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-country-published`,
                //         ifList: ['XX'], // others
                //         required: true,
                //         charLength: 50
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-country-published`,
                //         ifNotList: ['XX'],
                //         hide: true,
                //         setValue: () => ''
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-country-published`],
                    charLength: 50,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-country-published`] === 'XX'); // XX = others
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-country-published`] === 'XX');
                        return !result;
                    }
                }
            },
            {
                id: 'no-of-copies-imported',
                label: 'No. of Copies Imported',
                type: 'number',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: [''],
                //         required: true,
                //         charLength: 20
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: [''],
                //         hide: true
                //     }
                // ]
                rule: {
                    charLength: 9,
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return !result;
                    }
                }
            },
            {
                id: 'reason-submission',
                label: 'Reason for Submission',
                type: 'longText',
                span: 12,
                textRows: 4,
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifNotList: [''],
                //         required: true,
                //         charLength: 500
                //     },
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: [''],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    charLength: 500,
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return !result;
                    }
                }
            },
            {
                id: 'physical-copy',
                label: 'Select if you are submitting a physical copy',
                type: 'checkbox',
                span: 12,
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: [''],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return !result;
                    }
                }
            },
            {
                id: 'attachments',
                label: 'Attachments',
                type: 'file',
                category: 'SupportingDocuments',
                preventDelete: true,
                span: 12,
                fileTypes: ['.jpeg', '.jpg', '.png', '.bmp', '.mp4', '.mpeg', '.mov', '.pdf', '.xls', '.doc', '.xlsx', '.docx'],
                mimeTypes: [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    // 'text/plain',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    // 'image/gif',
                    'image/bmp',
                    'video/quicktime',
                    'video/mp4',
                    'video/mpeg'
                ],
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: [''],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return !result;
                    }
                }
            },
            {
                id: 'link-to-attachments',
                label: 'Link to Supporting Documents',
                placeholder: 'Eg: https://yourdocumentlink.com/',
                type: 'url',
                // rule: [
                //     {
                //         baseField: `${SECT_PUB_DETAILS}-publication-type`,
                //         ifList: [''],
                //         hide: true
                //     }
                // ]
                rule: {
                    baseIds: [`${SECT_PUB_DETAILS}-publication-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_PUB_DETAILS}-publication-type`]);
                        return !result;
                    }
                }
            }
        ]
    }
];

export default PUBLICATION_TITLE;
